import "./container.css";
import "./PricingRates.css";

const LoanIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11 15H13C13.5304 15 14.0391 14.7893 14.4142 14.4142C14.7893 14.0391 15 13.5304 15 13C15 12.4696 14.7893 11.9609 14.4142 11.5858C14.0391 11.2107 13.5304 11 13 11H10C9.4 11 8.9 11.2 8.6 11.6L3 17" stroke="#283AAA" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 21L8.6 19.6C8.9 19.2 9.4 19 10 19H14C15.1 19 16.1 18.6 16.8 17.8L21.4 13.4C21.7859 13.0354 22.0111 12.5323 22.0261 12.0016C22.0411 11.4709 21.8447 10.9559 21.48 10.57C21.1153 10.1841 20.6123 9.95892 20.0816 9.94392C19.5508 9.92891 19.0359 10.1254 18.65 10.49L14.45 14.39" stroke="#283AAA" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 16L8 22" stroke="#283AAA" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 11.9C17.6016 11.9 18.9 10.6016 18.9 8.99998C18.9 7.39835 17.6016 6.09998 16 6.09998C14.3983 6.09998 13.1 7.39835 13.1 8.99998C13.1 10.6016 14.3983 11.9 16 11.9Z" stroke="#283AAA" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 8C7.65685 8 9 6.65685 9 5C9 3.34315 7.65685 2 6 2C4.34315 2 3 3.34315 3 5C3 6.65685 4.34315 8 6 8Z" stroke="#283AAA" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CautionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M14.4866 12L9.15329 2.66665C9.037 2.46146 8.86836 2.29078 8.66457 2.17203C8.46078 2.05329 8.22915 1.99072 7.99329 1.99072C7.75743 1.99072 7.52579 2.05329 7.322 2.17203C7.11822 2.29078 6.94958 2.46146 6.83329 2.66665L1.49995 12C1.38241 12.2036 1.32077 12.4346 1.32129 12.6697C1.32181 12.9047 1.38447 13.1355 1.50292 13.3385C1.62136 13.5416 1.79138 13.7097 1.99575 13.8259C2.20011 13.942 2.43156 14.0021 2.66662 14H13.3333C13.5672 13.9997 13.797 13.938 13.9995 13.8208C14.202 13.7037 14.3701 13.5354 14.487 13.3327C14.6038 13.1301 14.6653 12.9002 14.6653 12.6663C14.6652 12.4324 14.6036 12.2026 14.4866 12Z" stroke="#032799" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 6V8.66667" stroke="#032799" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 11.3334H8.00667" stroke="#032799" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PLANS = [
  {
    title: "Loan up to 6 months",
    cardClass: "pricing-card--plain",
    tableClass: "pricing-table--bordered",
    icon: <LoanIcon />,
    planTypeLines: ["Smart Short", "Term Plan", "(SSTP)"],
    interest: "15.75% p.a. onwards",
    footnote: "Best suited for quick debt closure with lower tenure commitments.",
  },
  {
    title: "Loan up to 12 months",
    cardClass: "pricing-card--tinted",
    tableClass: "pricing-table--bordered",
    icon: <LoanIcon />,
    planTypeLines: ["Smart Long", "Term Plan", "(SLTP)"],
    interest: "17.25% p.a. onwards",
    footnote: "Lower EMIs with extended tenure for better monthly management.",
  },
];

const PricingRates = () => {
  return (
    <section className="pricing-rates w-full">
      <div className="container-8xl">
        <div className="pricing-rates-grid">
          {/* Left: copy */}
          <div>
            <h2
              className="pricing-heading"
              style={{ fontStyle: "normal", fontFamily: "Inter" }}
            >
              <span style={{ color: "#111827", fontWeight: 500 }}>Debt Consolidation</span>
              <br />
              <span style={{ color: "#283AAA", fontWeight: 700 }}>Loan Interest Rates (2026)</span>
            </h2>

            <p
              className="pricing-subtext"
              style={{ color: "#5D5D5D", fontStyle: "normal", fontWeight: 400, fontFamily: "Inter" }}
            >
              Designed to give you control, clarity, and competitive repayment
              options.
            </p>

            <a
              href={import.meta.env.VITE_WEBSITE_LINK}
              target="_blank"
              rel="noreferrer"
              className="pricing-apply-btn inline-flex items-center gap-2 font-['Inter'] font-[500] text-white transition-transform hover:scale-105"
              style={{
                borderRadius: "12px",
                background: "linear-gradient(0deg, #032799 0%, #032799 100%), #283AAA",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
              }}
            >
              Apply Now
              <span aria-hidden="true">→</span>
            </a>
          </div>

          {/* Right: cards */}
          <div>
            <div className="pricing-cards">
              {PLANS.map((plan) => (
                <div key={plan.title} className={`pricing-card ${plan.cardClass}`}>
                  <div
                    className="pricing-card-title"
                    style={{ color: "#111827", fontWeight: 600, fontFamily: "Inter" }}
                  >
                    {plan.icon}
                    {plan.title}
                  </div>

                  <table className={`pricing-table ${plan.tableClass}`}>
                    <thead>
                      <tr>
                        <th>Loan Type</th>
                        <th>Interest</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {plan.planTypeLines.map((line, index) => (
                            <span key={line} style={{ whiteSpace: "nowrap" }}>
                              {line}
                              {index < plan.planTypeLines.length - 1 && <br />}
                            </span>
                          ))}
                        </td>
                        <td>{plan.interest}</td>
                      </tr>
                    </tbody>
                  </table>

                  <p className="pricing-card-footnote">{plan.footnote}</p>
                </div>
              ))}
            </div>

            <div
              className="pricing-disclaimer"
              style={{ color: "#032799", fontStyle: "italic", fontWeight: 400, fontFamily: "Inter" }}
            >
              <CautionIcon />
              Interest rates may vary based on credit profile, income, and
              existing obligations.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingRates;
